export const coreApiMode = import.meta.env.VITE_D1_CORE_API === 'true';
export const landingPath = coreApiMode ? '/assets' : '/dashboard';
